const key = "HyT5tQTVXnw60lnjCByX4Xc92iUEwoGcF3wH5ptSEtFrEmhpl5";
const headers = {"accept":"application/json",
"content-type":"application/json",
"x-api-key":key};

export const callCheckout = async (tickets,event_date_id)=>{
    const body = JSON.stringify({
        tickets,
        event_date_id,
        shipping_method_id: 1
        
    });
   const result = await  fetch("https://api.ticketzone.com/publicApi/order", {
        headers,
        body,
        method:"POST",
        mode:"cors"
    });
    const result_json = await result.json();

    const {redirect} = result_json ;
    return redirect
}






/*
tickets
{
		"39663":{
			"qty":2
		}
	}
*/